import { Injectable, OnDestroy } from '@angular/core';

import { ProductConfig } from 'app/product-designer-config';
import { ProductService } from 'core/product/product.service';
import { Utils } from 'core/utils';
import { AsyncEventEmitterSubscriber } from 'core/utils/async-event-emitter';
import { Price } from './price';

@Injectable()
export class PriceCalculationService implements OnDestroy
{
  public singleProductTotal: Price; /* quantity one */
  public productTotal: Price;
  public currentTotal: Price;

  private productHasChangedSubscription:
      AsyncEventEmitterSubscriber<ProductConfig>;

  constructor(private productService: ProductService)
  {
    this.productHasChangedSubscription = this.productService.productHasChanged
      .subscribe(async (productConfig: ProductConfig) => {
        this.calculateTotalPrice(productConfig);
      });
    this.calculateTotalPrice();
  }

  public ngOnDestroy(): void
  {
    this.productService.productHasChanged.unsubscribe(
        this.productHasChangedSubscription);
  }

  public calculateTotalPrice(productConfig: ProductConfig =
      this.productService.getCurrentProduct()): void
  {
    this.singleProductTotal = this.getProductPriceWithFeatures(productConfig);
    this.productTotal = new Price(
        this.singleProductTotal, productConfig.quantity);
    this.currentTotal = Object.create(this.productTotal).add(
        this.getAdditionalProductsPrice(productConfig));
  }

  private getSingleFeaturesPrice(productConfig: ProductConfig): Price
  {
    let price = new Price();

    for (let featureGroupId of
        Object.keys(productConfig.featureGroups)) {
      const fg = productConfig.featureGroups[featureGroupId];
      if (fg.selectedFeature) {
        price.add(Utils.getCurrentPriceConfig(
            fg.features[fg.selectedFeature].price, productConfig.quantity));
      }
    }

    return price;
  }

  private getAdditionalProductsPrice(productConfig: ProductConfig): Price
  {
    let price = new Price();

    for (let additionalProductId of productConfig.selectedAdditionalProducts) {
      let additionalProduct = productConfig.additionalProducts
        .filter((ap) => ap.id === additionalProductId)[0];

      price.add(
          this.getProductPriceWithFeatures(additionalProduct),
          additionalProduct.quantity);
    }

    return price;
  }

  public getProductPriceWithFeatures(productConfig: ProductConfig): Price
  {
    const price = new Price(Utils.getCurrentPriceConfig(
        productConfig.price, productConfig.quantity));
    price.add(this.getSingleFeaturesPrice(productConfig));
    return price;
  }
}
